export default class PasswordValidator {
    static validations = [];

    static appendValidations(value) {
        if(Array.isArray(value)){
            this.validations = [...value];
        } else {
            this.validations.push({...value});
        }
    }

    static getValidations(){
        return [...this.validations];
    }

    static validate(valueString){

        for(let i =0; i < this.validations.length; i++){
            let validation = this.validations[i];
            switch(validation?.condition?.type){
                case 'LENGTH':
                    switch(validation.condition.operator){
                        case 'MINIMUM':
                            validation = {...validation, result: valueString.length >= validation.condition.value}
                            break;
                        case 'MAXIMUM':
                            validation = {...validation, result: valueString.length <= validation.condition.value}
                            break;
                    }
                    break;
                case 'REGEX':
                    const result = new RegExp(validation.condition.value).test(valueString);
                    validation = {...validation, result: result}
                    break;
            }
            this.validations[i] = {...validation};
        }

        return this.validations;
    }
}